/**
 * Triggers the bounce effect when the diff becomes less than this value.
 *
 * @since 3.0.0
 */
export const BOUNCE_DIFF_THRESHOLD = 10;

/**
 * The duration of the bounce effect.
 *
 * @since 3.0.0
 */
export const BOUNCE_DURATION = 600;

/**
 * The friction factor.
 *
 * @since 3.0.0
 */
export const FRICTION_FACTOR = 0.6;

/**
 * The velocity to calculate the scroll duration.
 *
 * @since 3.0.0
 */
export const BASE_VELOCITY = 1.5;

/**
 * The minimum duration of scroll.
 *
 * @since 3.0.0
 */
export const MIN_DURATION = 800;
